<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KPj1l9/tc-custom/9781453259719.jpg?1734405497183" alt="This image is the cover for the book Boy Who Never Grew Up, The Stewart Hoag Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boy Who Never Grew Up, The Stewart Hoag Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A Hollywood ghostwriter and his basset hound explore the deadly world of high-stakes divorce in this hilarious mystery from an Edgar Award–winning author.</b><br/><br/> Matthew Wax is an overgrown kid with a taste for sweets, go-kart racing, and wholesome family comedy. He’s also the most successful director in Hollywood, a golden boy whose films are toothache sweet and spit-shine clean. But when his wife, leading lady Pennyroyal Brim, tires of life in a G-rated wonderland, she brings in the most ruthless lawyer on the West Coast: the notorious Abel Zorch. To win the divorce settlement, Zorch drags Wax through the mud, accusing him of perversion, misogyny, and abuse. So when Pennyroyal announces a tell-all memoir, Wax has only one choice: to call in Stewart “Hoagy” Hoag, ghostwriter to the stars.<br/><br/> Working with Wax, Hoagy and his basset hound, Lulu, get closer to the boy wonder than anyone else ever has. But when Zorch turns up dead, Wax is the prime suspect—followed closely by every spurned husband in Beverly Hills—and to clear their client’s name, the amateur sleuth and his canine companion will have to leave La-La Land behind and cross over to the dark side of Los Angeles.<br/><br/> From Edgar Award–winning author David Handler, <i>The Boy Who Never Grew Up</i> is a razor-sharp entry in the beloved Stewart Hoag Mysteries, called an “all-time favorite series” by Harlan Coben. The funniest sleuth around, Hoagy knows that quick wit can overcome any obstacle—even murder.<br/><br/> The Boy Who Never Grew Up <i>is the 5th book in the Stewart Hoag Mysteries, but you may enjoy reading the series in any order.</i><br/>    
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Handler
      </h2>
      
      <p class="authorDescription body article">David Handler (b. 1952) is the critically acclaimed author of several bestselling mystery series. He began his career as a New York City reporter, and wrote his first two novels&mdash;<i>Kiddo </i>(1987) and <i>Boss</i> (1988)&mdash;about his Los Angeles childhood. In 1988 he published <i>The Man Who Died Laughing</i>, the first of a series of mysteries starring ghostwriter Stuart Hoag and his faithful basset hound Lulu. Handler wrote eight of the novels, winning both Edgar and American Mystery awards for <i>The Man Who Would Be F. Scott Fitzgerald </i>(1990).&#160;<i>The Cold Blue Blood</i> (2001) introduced a new series character, New York film critic Mitch Berger, who fights his reclusive nature to solve crimes with the help of police Lieutenant Desiree Mitry. Handler has published eight novels starring the pair, with another, <i>The Snow White Christmas Cookie</i>, due out in 2012. In 2009 Handler published <i>Click to Play</i>, a stand-alone novel about an investigative reporter. He lives and writes in Old Lyme, Connecticut. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5474f62